import React from 'react';

import { FieldTypes } from '../FormLogs';
import CheckboxInput from '../../../Components/Inputs/CheckboxInput';
import FileUploader from '../../../Components/Inputs/FileUploader';
import SelectInput from '../../../Components/Inputs/SelectInput';
import SignatureField from "../../../Components/Inputs/SignatureField";
import HtmlFieldTermsAndCondition from "./FormlogFields/HtmlFieldTermsAndCondition";

const HtmlField = (props) => {

    const handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        if ([FieldTypes.TYPE_CHECKBOX, FieldTypes.TYPE_T_AND_C].includes(props.field.type)) {
            value = event.target.checked;
        }

        props.onChange(name, value)
    }

    const handleFileUploaderChange = (files) => {
        const e = {
            target: {
                type: 'file',
                name: props.field.id,
                value: files,
            }
        }
        handleChange(e);
    }

    const field = props.field;

    switch(field.type) {
        case FieldTypes.TYPE_TEXT:
            return (
                <input
                    type="text"
                    name={field.id}
                    className={`${field.text ? 'margin-bottom-0' : ''}`}
                    onChange={handleChange}
                    onBlur={props.onBlur}
                    value={props.value}
                />
            )

        case FieldTypes.TYPE_DROPDOWN:
            return (
                <SelectInput
                    name={field.id}
                    options={field.options.items}
                    isClearable={field.validations !== 'required'}
                    onChange={handleChange}
                    onBlur={props.onBlur}
                    value={props.value}
                />
            )

        case FieldTypes.TYPE_TEXTAREA:
            return (
                <textarea
                    name={field.id}
                    rows={4}
                    style={{ resize: 'none' }}
                    onChange={handleChange}
                    onBlur={props.onBlur}
                    value={props.value}
                />
            )

        case FieldTypes.TYPE_CONTENT:
            return (
                <>
                    <b>{field.label}</b>
                    <div>{field.helpful_text}</div>
                </>
            )

        case FieldTypes.TYPE_DATEPICKER:
            return (
                <input
                    type="date"
                    name={field.id}
                    className={`${field.text ? 'margin-bottom-0' : ''}`}
                    onChange={handleChange}
                    onBlur={props.onBlur}
                    value={props.value}
                />
            )

        case FieldTypes.TYPE_TIMEPICKER:
            return (
                <input
                    type="time"
                    name={field.id}
                    className={`${field.text ? 'margin-bottom-0' : ''}`}
                    onChange={handleChange}
                    onBlur={props.onBlur}
                    value={props.value}
                />
            )

        case FieldTypes.TYPE_CHECKBOX:
            // TODO - determine if a sub form is configured here
            // TODO - limit max form nesting
            return (
                <CheckboxInput
                    name={field.id}
                    onChange={handleChange}
                    onBlur={props.onBlur}
                    checked={(props.value === 'true' || props.value === true)}
                />
            )

        case FieldTypes.TYPE_T_AND_C:
            return ( <HtmlFieldTermsAndCondition {...props} onChange={handleChange} /> )

        case FieldTypes.TYPE_FILEUPLOAD:
            return (
                <FileUploader
                    name={field.id}
                    onBlur={props.onBlur}
                    value={props.value}
                    onChange={files => handleFileUploaderChange(files)}
                />
            )

        case FieldTypes.TYPE_IPAD:
            return (
                <SignatureField name={field.id} onChange={handleChange} />
            )

        default:
            console.log(`Unknown type: ${field.type}`);
            return null;
    }
}

export default HtmlField;
